"use client";

import React from "react";
import { Activity, Info, Syringe } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EstimatedTotalOutOfPocket() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}